(function () {
  function normalizeUrl(url) {
    if (!url) return "";
    if (url.startsWith("//")) return "https:" + url;
    return url;
  }

  function getProductJsonOnce() {
    // cache on window so it persists across calls
    if (window.__paProductJson && Array.isArray(window.__paProductJson.variants)) {
      return window.__paProductJson;
    }

    const candidates = [
      'script[type="application/json"][data-product-json]',
      'script[type="application/json"][id*="ProductJson"]',
      'script[type="application/json"][id*="product-json"]',
      'script[type="application/json"][id*="ProductJson-"]'
    ];

    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (!el) continue;
      try {
        const data = JSON.parse(el.textContent.trim());
        if (data && Array.isArray(data.variants)) {
          window.__paProductJson = data;
          return data;
        }
      } catch (e) {}
    }

    if (window?.meta?.product && Array.isArray(window.meta.product.variants)) {
      window.__paProductJson = window.meta.product;
      return window.meta.product;
    }
    if (window?.Shopify?.product && Array.isArray(window.Shopify.product.variants)) {
      window.__paProductJson = window.Shopify.product;
      return window.Shopify.product;
    }

    return null;
  }

  function optionIndexFromDataIndex(dataIndex) {
    const m = String(dataIndex || "").match(/option(\d+)/i);
    if (!m) return 0;
    return Math.max(0, parseInt(m[1], 10) - 1);
  }

  function findVariantImage(variant) {
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (variant?.featured_image) return variant.featured_image;
    if (variant?.image?.src) return variant.image.src;
    if (variant?.image) return variant.image;
    if (variant?.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
    return "";
  }

  // Build a lookup table once: key = `${optionIndex}::${optionValue}`
  function buildImageMapOnce(product) {
    if (window.__paVariantImageMap && window.__paVariantImageMap.__forProductId === product.id) {
      return window.__paVariantImageMap;
    }

    const map = new Map();
    (product.variants || []).forEach((v) => {
      const img = normalizeUrl(findVariantImage(v));
      if (!img) return;
      const opts = v.options || [];
      opts.forEach((optVal, idx) => {
        if (!optVal) return;
        map.set(`${idx}::${String(optVal)}`, img);
      });
    });

    // stash
    map.__forProductId = product.id;
    window.__paVariantImageMap = map;
    return map;
  }

  function syncProductPageChips(root) {
    const product = getProductJsonOnce();
    if (!product) return;

    const imgMap = buildImageMapOnce(product);

    const scope = root || document;
    const wraps = scope.querySelectorAll(
      ".product__color-chips.dynamic-variant-input-wrap[data-product-option]"
    );

    wraps.forEach((wrap) => {
      const optionIndex = optionIndexFromDataIndex(wrap.getAttribute("data-index"));
      const buttons = wrap.querySelectorAll(
        "button.dynamic-variant-button.product__chip[data-option-value]"
      );

      buttons.forEach((btn) => {
        const value = btn.getAttribute("data-option-value");
        if (!value) return;

        const imgUrl = imgMap.get(`${optionIndex}::${String(value)}`);
        if (!imgUrl) return;

        const icon = btn.querySelector(".variant-icon-img");
        if (!icon) return;

        // Avoid re-setting style if already correct (reduces repaint)
        const nextBg = `url("${imgUrl}")`;
        if (icon.dataset.bg === nextBg) return;

        icon.style.backgroundImage = nextBg;
        icon.dataset.bg = nextBg;
      });
    });
  }

  // schedule updates efficiently (no spam)
  let scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      syncProductPageChips(document);
    });
  }

  // Warm the HTTP cache for variant-chip images so the first variant switch is
  // fast — but at LOW priority and deferred until after load/idle, so it never
  // competes with the LCP paint. (Previously: a per-image <link rel=preload> +
  // fetchPriority="high" Image + a force-cache fetch — three high-priority
  // fetches per chip that fought the hero image for bandwidth on every PDP.)
  function warmChipImagesIdle() {
    const run = function () {
      const product = getProductJsonOnce();
      if (!product) return;

      const imgMap = buildImageMapOnce(product);
      const buttons = document.querySelectorAll(
        ".product__color-chips.dynamic-variant-input-wrap[data-product-option] button.dynamic-variant-button.product__chip[data-option-value]"
      );
      if (!buttons.length) return;

      const urls = new Set();
      buttons.forEach((btn) => {
        const wrap = btn.closest(".dynamic-variant-input-wrap[data-index]");
        if (!wrap) return;
        const optionIndex = optionIndexFromDataIndex(wrap.getAttribute("data-index"));
        const value = btn.getAttribute("data-option-value");
        if (!value) return;
        const u = imgMap.get(`${optionIndex}::${String(value)}`);
        if (u) urls.add(u);
      });

      urls.forEach((u) => {
        if (!u) return;
        const img = new Image();
        try { img.fetchPriority = "low"; } catch (e) {}
        img.decoding = "async";
        img.src = u; // browser caches it; the click handler reads the same URL
      });
    };

    const schedule = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2000 });
      else setTimeout(run, 300);
    };
    if (document.readyState === "complete") schedule();
    else window.addEventListener("load", schedule, { once: true });
  }

  function boot() {

    document.addEventListener("click", (e) => {
  const btn = e.target && e.target.closest
    ? e.target.closest("button.dynamic-variant-button.product__chip")
    : null;
  if (!btn) return;

  // immediate paint: set icon NOW
  const wrap = btn.closest(".dynamic-variant-input-wrap[data-index]");
  const product = getProductJsonOnce();
  if (wrap && product) {
    const imgMap = buildImageMapOnce(product);
    const optionIndex = optionIndexFromDataIndex(wrap.getAttribute("data-index"));
    const value = btn.getAttribute("data-option-value");
    const imgUrl = value ? imgMap.get(`${optionIndex}::${String(value)}`) : "";
    const icon = btn.querySelector(".variant-icon-img");
    if (imgUrl && icon) {
      const nextBg = `url("${imgUrl}")`;
      icon.style.backgroundImage = nextBg;
      icon.dataset.bg = nextBg;
    }
  }

  scheduleSync();
}, true);

    // run ASAP (don’t wait for images)
    scheduleSync();
    // warm chip images at low priority once the page is loaded/idle (keeps
    // switching fast without competing with LCP)
    warmChipImagesIdle();

    // run when the select changes
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (t && t.matches("select.dynamic-variant-input")) scheduleSync();
    });

    // run when a chip is clicked (instant feedback)
    document.addEventListener("click", (e) => {
      const btn = e.target && e.target.closest
        ? e.target.closest("button.dynamic-variant-button.product__chip")
        : null;
      if (btn) scheduleSync();
    }, true);

    // mutation observer throttled to RAF
    const mo = new MutationObserver(() => scheduleSync());
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();